import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const UserInfoCard = ({ userData }) => {
  const date = new Date( userData?.createdAt || Date.now());
  const dateOfJoining = date.toISOString().split("T")[0];
  const deviceInfo = "Device info here";

  return (
    <div className="container my-4">
      <h6 className="text-left fw-bold">Other</h6>
      <div className="card shadow-sm" style={{ width: "18rem" }}>
        <div className="card-body d-flex flex-column">
          <div className="mt-auto d-flex justify-content-between">
            <div>
              <div style={{ fontSize: 12 }}>Date of Joining:</div>
              <p>
                <b>{dateOfJoining}</b>
              </p>
            </div>
            <div>
              <div style={{ fontSize: 12 }}>Device Info:</div>
              <p>
                <b>{deviceInfo}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfoCard;
